import { render, staticRenderFns } from "./TalkRank.vue?vue&type=template&id=42ba1b28&scoped=true&"
import script from "./TalkRank.vue?vue&type=script&lang=ts&"
export * from "./TalkRank.vue?vue&type=script&lang=ts&"
import style0 from "./TalkRank.vue?vue&type=style&index=0&id=42ba1b28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ba1b28",
  null
  
)

export default component.exports